import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../utils/firebase';
import { getAuthErrorMessage } from "../utils/Helper";
import ForgotPassword from './ForgotPassword'; // Ensure the filename matches

const Login = ({ onSendToParent }) => {
    // Initial states for the session
    localStorage.setItem("isAnon", true);
    localStorage.setItem("email", "Login");

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const onLogin = (e) => {
        e.preventDefault();
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                localStorage.setItem("isAnon", userCredential.user.isAnonymous);
                localStorage.setItem("email", userCredential.user.email);
                onSendToParent(userCredential);
            }).catch((error) => {
                toast.error(getAuthErrorMessage(error.code));
            });
    }

    const sendToParentRegister = (data) => {
        onSendToParent("Register");
    }

    return (
        <>
            <main>
                <section className=' animate-fade-in border-0'>
                       <div><h4 className="xTitle animated fadeInLeft">Albuquerque Press Club</h4></div>
                    <h3 className="auth-title">Access Site</h3>
                    
                    <div className="auth-body">
                        <form onSubmit={onLogin}>
                            <div className="auth-form-group">
                                <label className="meta-label" htmlFor="email-address">
                                    Email address
                                </label>
                                <input
                                    id="email-address"
                                    name="email"
                                    type="email"
                                    required
                                    className="glass-input"
                                    placeholder="name@example.com"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>

                            <div className="auth-form-group">
                                <label className="meta-label" htmlFor="password">
                                    Password
                                </label>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    required
                                    className="glass-input"
                                    placeholder="••••••••"
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn-glass-save-edit w-100" 
                                style={{ width: '100%', marginTop: '10px' }}>
                                Login
                            </button>
                        </form>

                        {/* Password Recovery Tool */}
                        <ForgotPassword />

                        <div className="auth-divider">
                            <hr />
                            <span>OR</span>
                        </div>

                        <div className="auth-footer">
                            <p className="meta-label gold-accent" style={{ textAlign: 'center', marginBottom: '10px' }}>
                                Don't have account yet?
                            </p>
                            <button 
                                className="btn-glass-create w-100" 
                                style={{ width: '100%' }}
                                onClick={sendToParentRegister}>
                                Register
                            </button>
                        </div>
                    </div>

                    <ToastContainer
                        position="bottom-center"
                        autoClose={5000}
                        theme="dark"
                    />
                </section>
            </main>
        </>
    )
}

export default Login;